/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { type JSX } from 'react'
import * as THREE from 'three'
import { type GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      ['Cube-Mesh']: THREE.Mesh
      ['Cube-Mesh_1']: THREE.Mesh
      ['Cube-Mesh_2']: THREE.Mesh
    }
    materials: {
      ['Material.003']: THREE.MeshStandardMaterial
      ['Material.004']: THREE.MeshStandardMaterial
      ['Material.006']: THREE.MeshStandardMaterial
    }
  }

export function Console(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/console.glb') as GLTFResult

  return (
    <group {...props} dispose={null}>
      <group position-y={0.25} rotation-x={THREE.MathUtils.degToRad(-90)}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Cube-Mesh'].geometry}
          material={materials['Material.003']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Cube-Mesh_1'].geometry}
          material={materials['Material.004']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Cube-Mesh_2'].geometry}
          material={materials['Material.006']}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/console.glb')
